export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70a1c92d7cba6cba202874f9a62c53121b0cdc1e5f&name=pushAdClickData!'